import React from "react";
import { useTranslation } from "react-i18next";
import { useCalismaDurumu } from "../data/isletme";

/**
 * "Şu an açık · 20:00'de kapanıyor" / "Şu an kapalı · Yarın 08:00'de açılıyor" rozeti.
 * koyu: koyu zemin üzerinde (kayan şerit), yoksa açık zemin.
 */
export default function CalismaRozeti({ koyu = false, kisa = false }) {
  const { t } = useTranslation();
  const d = useCalismaDurumu();

  const renk = d.acik ? (d.sonSaat ? "bg-amber-400" : "bg-emerald-500") : "bg-rose-500";
  const ana = d.acik ? t("hours.open") : t("hours.closed");
  const ek = d.acik
    ? t("hours.closesAt", { saat: d.kapanis })
    : d.gunFarki === 0
    ? t("hours.opensToday", { saat: d.acilis })
    : t("hours.opensTomorrow", { saat: d.acilis });

  return (
    <span className={`inline-flex items-center gap-2 whitespace-nowrap text-[12.5px] ${koyu ? "text-white/85" : "text-body"}`}>
      <span className="relative flex h-2 w-2">
        {d.acik && <span className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-60 ${renk}`} />}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${renk}`} />
      </span>
      <span className={`font-semibold ${koyu ? "text-white" : "text-ink"}`}>{ana}</span>
      {!kisa && <span className={koyu ? "text-white/60" : "text-muted"}>· {ek}</span>}
    </span>
  );
}
